export const SIDEBAR_MAX_VISIBLE_ITEMS = 10;

export const SIDEBAR_CONSTANTS = {
  MAX_WIDTH: 400,
  MIN_WIDTH: 80,
  DEFAULT_EXPANDED_WIDTH: 210,
  COLLAPSE_THRESHOLD: 140,
  HEADER_HEIGHT: 48,
  TOGGLE_BUTTON_SIZE: 24,
  RESIZE_HANDLE_WIDTH: 1,
} as const;

export const SIDEBAR_POSITIONS = {
  EXPANDED_TOGGLE_LEFT: 185,
  COLLAPSED_TOGGLE_LEFT: 52,
} as const;
